// extracted by mini-css-extract-plugin
export default {"item":"cookieListItem_item","id":"cookieListItem_id","row":"cookieListItem_row","title":"cookieListItem_title","label":"cookieListItem_label","info":"cookieListItem_info"};